/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import { useSelector } from 'react-redux';
import mbpLogger from 'mbp-logger';
import useSalesforcePersonalizedContentQuery from '../../../../../../helpers/Personalization/useSalesforcePersonalizedContentQuery';
import useClickStreamCustomEventsTracking from '../../../../../../helpers/Personalization/useClickstreamCustomEventsTracking';
import { getBrand } from '../../../../../../../state/ducks/App/ducks/Brand/Brand-Selectors';
import { getCurrentPageType } from '../../../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Selectors';

const DeliveryCalendarSFContainer = ({ render }) => {
    const brand = useSelector(getBrand);
    const pageType = useSelector(getCurrentPageType);

    const {
        error, data,
    } = useSalesforcePersonalizedContentQuery({
        queryName: 'CCOCalendarTest',
        interactionName: 'Cheryls - Get Campaign - Calendar Design On GPT Products',
        optInHoldoutParticipation: false,
        resolveIdentity: false,
    });

    if (error) {
        mbpLogger.logError({
            function: 'DeliveryCalendarSFContainer',
            message: 'Error loading API data',
            appName: process.env.npm_package_name,
            module: 'PersonalizedContent',
            jsError: error,
        });
    }

    const userGroup = data?.contentSF?.campaign?.campaignResponses?.[0]?.payload?.userGroup;

    const trackClickThrough = useClickStreamCustomEventsTracking({
        salesforceResponse: data?.contentSF,
        isFireImpression: true,
        page: { type: pageType },
    });

    return render({
        userGroup, trackClickThrough,
    });
};

export default DeliveryCalendarSFContainer;
